import type { CogsSkuScope } from "@/lib/manufacturing/cogsCatalogView";

const SCOPES: Array<{ id: CogsSkuScope; label: string }> = [
  { id: "products", label: "Products" },
  { id: "addons", label: "Options & packages" },
  { id: "all", label: "All" },
];

export function ManufacturingPricingSkuScope({
  value,
  disabled,
  onChange,
}: {
  value: CogsSkuScope;
  disabled: boolean;
  onChange: (scope: CogsSkuScope) => void;
}) {
  return (
    <div
      role="tablist"
      aria-label="SKU kind"
      className="flex rounded-lg bg-gray-100 p-0.5 text-xs dark:bg-zinc-900"
    >
      {SCOPES.map((scope) => (
        <button
          key={scope.id}
          type="button"
          role="tab"
          aria-selected={value === scope.id}
          disabled={disabled}
          className={
            "rounded-md px-2.5 py-1 font-semibold " +
            (value === scope.id
              ? "bg-white text-gray-900 shadow-sm dark:bg-zinc-950 dark:text-zinc-100"
              : "text-gray-600 dark:text-zinc-400")
          }
          onClick={() => onChange(scope.id)}
        >
          {scope.label}
        </button>
      ))}
    </div>
  );
}
